<div class="relative inline-block text-left" #container>
  <ng-container
    *ngTemplateOutlet="dropdownTrigger(); context: context()"
  ></ng-container>

  @if (!dropdownTrigger()) {
    <div
      role="button"
      class="inline-flex items-center justify-center bg-transparent p-1 text-neutral-low-dark shadow-sm hover:text-neutral-low-pure focus:outline-none focus:ring-2 focus:ring-brand-primary-pure focus:ring-offset-2"
      [ngClass]="{
        'rounded-full': variant() === 'icon',
        'rounded-md': variant() === 'text' || variant() === 'both',
        'text-sm font-medium': variant() === 'text' || variant() === 'both'
      }"
      [attr.id]="'menu-button-' + uniqueId()"
      [attr.aria-haspopup]="hasCustomContent() ? 'true' : 'menu'"
      [attr.aria-expanded]="expanded()"
      [attr.aria-controls]="'menu-' + uniqueId()"
      (click)="toggleExpanded()"
    >
      <span class="sr-only">Open options</span>

      @if (variant() === 'text' || variant() === 'both') {
        <span
          [ngClass]="{
            'mr-1': variant() === 'both'
          }"
        >
          {{ name() }}
        </span>
      }

      @if (variant() === 'icon' || variant() === 'both') {
        <ng-icon [name]="icon()" size="20" />
      }
    </div>
  }

  @if (expanded() !== null) {
    <div
      #menuElement
      class="absolute z-50 max-h-[calc(100vh-2rem)] overflow-y-auto rounded-md border border-neutral-hight-medium bg-neutral-hight-light shadow-lg transition-all ease-in-out focus:outline-none"
      [ngClass]="{
        'left-0': direction() === 'right',
        'right-0': direction() === 'left',
        'top-full mt-2': placement() === 'bottom',
        'bottom-full mb-2': placement() === 'top',
        'invisible scale-95 opacity-0': !expanded(),
        'visible scale-100 opacity-100': expanded(),
        'w-56': size() === 'base',
        'w-64': size() === 'lg',
        'origin-top-right': direction() === 'right' && placement() === 'bottom',
        'origin-top-left': direction() === 'left' && placement() === 'bottom',
        'origin-bottom-right': direction() === 'right' && placement() === 'top',
        'origin-bottom-left': direction() === 'left' && placement() === 'top'
      }"
      role="menu"
      aria-orientation="vertical"
      [attr.aria-labelledby]="'menu-button-' + uniqueId()"
      tabindex="-1"
    >
      @if (hasCustomContent()) {
        <ng-container
          *ngTemplateOutlet="dropdownContent(); context: context()"
        />
      } @else {
        <div class="py-1" role="none">
          @for (item of items(); track $index) {
            <button
              (click)="onActionDispatch(item.action)"
              class="inline-flex w-full cursor-pointer items-center !gap-3 !px-4 py-2 text-sm font-medium transition-colors duration-150 disabled:cursor-not-allowed disabled:opacity-60"
              [ngClass]="{
                'text-feedback-warning-pure enabled:hover:bg-feedback-warning-light/35 enabled:hover:text-feedback-warning-medium':
                  item.name?.toLowerCase() === 'excluir' ||
                  item.name?.toLowerCase() === 'deletar' ||
                  item.name?.toLowerCase() === 'remover' ||
                  item.name?.toLowerCase() === 'sair',
                'text-neutral-low-dark enabled:hover:bg-brand-primary-lighter enabled:hover:text-neutral-low-pure':
                  item.name?.toLowerCase() !== 'excluir' &&
                  item.name?.toLowerCase() !== 'deletar' &&
                  item.name?.toLowerCase() !== 'remover' &&
                  item.name?.toLowerCase() !== 'sair',
                hidden: item.hidden
              }"
              [disabled]="item.disabled"
              role="menuitem"
              tabindex="-1"
              id="menu-item-{{ $index }}"
              [attr.data-tracking-id]="item.tracking?.id"
              [attr.data-tracking-object]="
                item.tracking?.data ? (item.tracking?.data | json) : undefined
              "
            >
              @if (item.icon) {
                <ng-icon [name]="item.icon" size="18"></ng-icon>
              }
              {{ item.name }}
            </button>
          }
        </div>
      }
    </div>
  }
</div>

<div [uiOverlay]="expanded()" (clickOutside)="toggleExpanded()"></div>
